export enum CustomizableColor {
	ACTION = 4,
	HEADER_BACKGROUND = 1,
	HEADER_TEXT = 6,
	PRIMARY_BACKGROUND = 10,
	SECONDARY_BACKGROUND = 3,
}
